import { Box, IconButton, Button, useTheme, Container, Stack, Stepper, Step, StepLabel, CircularProgress } from "@mui/material"
import { useNavigate } from "react-router"
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import SaveIcon from '@mui/icons-material/Save'
import { styled } from '@mui/material/styles'
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector'
import ViewInArIcon from '@mui/icons-material/ViewInAr';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import SplitscreenIcon from '@mui/icons-material/Splitscreen';
import HelmetIcon from '../../../assets/helmet.png';
import ResponseSubTasksIcon from '../../../assets/response-tasks.png'
import WidgetsIcon from '@mui/icons-material/Widgets';
import PropTypes from 'prop-types'

//Components
import AssetFormComponent from '../components/createUpdate/AssetFormComponent'
import TaskFormComponent from '../components/createUpdate/TaskFormComponent'
import SubTaskFormComponent from '../components/createUpdate/SubTaskFormComponent'
import ResourceFormComponent from '../components/createUpdate/ResourceFormComponent'
import SegurityFormComponent from '../components/createUpdate/SegurityFormComponent'
import ResponseSubTasksComponent from '../components/createUpdate/ResponseSubTasksComponent'

import { useTaskContext } from '../../../shared/context/taskContext'

import { useState, useEffect } from 'react'
const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 22,
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundImage:
                'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            backgroundImage:
                'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        height: 3,
        border: 0,
        backgroundColor: '#cacfd2',
        borderRadius: 1,
        ...theme.applyStyles('dark', {
            backgroundColor: theme.palette.grey[800],
        }),
    },
}));

const ColorlibStepIconRoot = styled('div')(({ theme }) => ({
    backgroundColor: '#ccc',
    zIndex: 1,
    color: '#fff',
    width: 30,
    height: 30,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    ...theme.applyStyles('dark', {
        backgroundColor: theme.palette.grey[700],
    }),
    variants: [
        {
            props: ({ ownerState }) => ownerState.active,
            style: {
                backgroundImage:
                    'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
                boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
            },
        },
        {
            props: ({ ownerState }) => ownerState.completed,
            style: {
                backgroundImage:
                    'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
            },
        },
    ],
}));

function ColorlibStepIcon(props) {
    const { active, completed, className, taskRealized } = props;

    const icons = {
        1: <ViewInArIcon sx={{ fontSize: '20px' }} />,
        2: <AssignmentTurnedInIcon sx={{ fontSize: '20px' }} />,
        3: <SplitscreenIcon sx={{ fontSize: '20px' }} />,
        4: <img src={taskRealized ? ResponseSubTasksIcon : HelmetIcon} alt="helmet" style={{ width: '20px', height: '20px' }} />,
        //5: taskRealized ? <img src={HelmetIcon} alt="helmet" style={{ width: '20px', height: '20px' }} /> : <WidgetsIcon sx={{ fontSize: '20px' }} /> ,
    };

    if (taskRealized) {
        icons[5] = <img src={HelmetIcon} alt="helmet" style={{ width: '20px', height: '20px' }} /> 
    }

    return (
        <ColorlibStepIconRoot ownerState={{ completed, active }} className={className}>
            {icons[String(props.icon)]}
        </ColorlibStepIconRoot>
    );
}

ColorlibStepIcon.propTypes = {
    /**
     * Whether this step is active.
     * @default false
     */
    active: PropTypes.bool,
    className: PropTypes.string,
    /**
     * Mark the step as completed. Is passed to child components.
     * @default false
     */
    completed: PropTypes.bool,
    /**
     * The label displayed in the step icon.
     */
    icon: PropTypes.node,
    taskRealized: PropTypes.bool,
};

const steps = ['Activo', 'Tarea', 'SubTareas', 'SSOMA'];

const stepsRealized = ['Activo', 'Tarea', 'SubTareas', 'Values', 'SSOMA'];




const stepContent = (stepActive, taskRealized) => {
    const component = {
        1: <AssetFormComponent />,
        2: <TaskFormComponent />,
        3: <SubTaskFormComponent />,
        4: taskRealized ? <ResponseSubTasksComponent /> : <SegurityFormComponent />,
        //5: taskRealized ? <SegurityFormComponent /> : <ResourceFormComponent />,

        
    } 

    if (taskRealized) {
        component[5] = <SegurityFormComponent />
    }
 /*
    if (taskRealized) {
        component[6] = <ResourceFormComponent />
    }
    */

    return component[stepActive]
}






import { useAbility } from '../../../shared/context/AbilityContext'




export default function TaskCreateUpdateView() {
    const navigate = useNavigate()
    const theme = useTheme()

    const ability = useAbility();

    const { stepActive, handleStep, handleStepBack,  loadingSaveTask, createTask, loadingCreateTask, conditions } = useTaskContext()


    //si el usuario no tiene permisos para crear tareas, se redirige a la lista de tareas
    useEffect(() => {
        if(!ability.can('create', 'TASK')){
            navigate('/task/wo')
        }
    }, [ability])






    return (
        <Container maxWidth="xl" sx={{
            padding: '0px', margin: '0px',
        }}>
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '5px'
            }}>
                <IconButton
                    onClick={() => navigate('/task/wo')}
                    sx={{
                        borderRadius: '12px',
                        padding: '8px',
                        backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.03)',
                        transition: 'all 0.2s',
                        "&:hover": {
                            backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)',
                            transform: 'translateY(-2px)'
                        }
                    }}
                >
                    <ArrowBackIcon />
                </IconButton>

               {/* <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    type='submit'
                    disabled={loadingCreateTask || loadingSaveTask}
                    sx={{
                        borderRadius: '8px',
                        padding: '8px 25px',
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText,
                        borderRadius: '50px',
                        transition: 'all 0.2s',

                        "&:hover": {
                            backgroundColor: theme.palette.primary.dark,
                            transform: 'translateY(-2px)'
                        }
                    }}
                    onClick={createTask}
                >
                    {loadingCreateTask ? <CircularProgress size={20} /> : "Guardar"}
                </Button> */}
            </Box>

            <Stack sx={{ width: '100%', marginBottom: '5px' }} spacing={4}>

                <Stepper alternativeLabel activeStep={stepActive - 1} connector={<ColorlibConnector />}>
                    { conditions.task_realized ? stepsRealized.map((label) => (
                        <Step key={label}>
                            <StepLabel StepIconComponent={(props) => <ColorlibStepIcon taskRealized={conditions.task_realized} {...props} />} 
                            sx={{ "& .MuiStepLabel-label": { fontSize: { xs: '11px', md: '14px' }, marginTop: { xs: '2px !important', md: '5px' } } }}>{label}</StepLabel>
                        </Step>
                    )) : steps.map((label) => (
                        <Step key={label}>
                            <StepLabel StepIconComponent={(props) => <ColorlibStepIcon {...props} />} 
                            sx={{ "& .MuiStepLabel-label": { fontSize: { xs: '11px', md: '14px' }, marginTop: { xs: '2px !important', md: '5px' } } }}>{label}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
            </Stack>


            <Box sx={{
                borderRadius: '10px',
                backgroundColor: theme.palette.background.paper,
                padding: { xs: '10px', md: '20px' },
                minHeight: '600px',
                position: 'relative'
            }}>
                {stepContent(stepActive, conditions.task_realized)}
            {/*
                <Box sx={{ display: 'flex', justifyContent: 'start', gap: '10px', alignItems: 'center', marginTop: '20px', position: 'absolute', bottom: '20px', left: '20px', right: '20px' }}>
                    <Button
                        variant="contained"
                        onClick={handleStepBack}
                        disabled={stepActive === 1}
                        sx={{
                            borderRadius: '8px',
                            padding: '8px 25px',
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.primary.contrastText,
                            borderRadius: '50px',
                            transition: 'all 0.2s',
                            "&:hover": {
                                backgroundColor: theme.palette.primary.dark,
                                transform: 'translateY(-2px)'
                            }
                        }}
                    >
                        Anterior
                    </Button>

                    <Button
                        variant="contained"
                        onClick={handleStep}
                        sx={{
                            borderRadius: '8px',
                            padding: '8px 25px',
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.primary.contrastText,
                            borderRadius: '50px',
                            transition: 'all 0.2s',
                            "&:hover": {
                                backgroundColor: theme.palette.primary.dark,
                                transform: 'translateY(-2px)'
                            }
                        }}
                    >
                        Siguiente
                    </Button>
                </Box>
            */}

            </Box>
        </Container>
    )
}